module.exports = __webpack_public_path__ + "static/img/exhibit-1.108ca2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/exhibit-1.jpg
// module id = NdzN
// module chunks = 52